/**
 * HLS.js config tuned for LIVE streaming:
 * - liveDurationInfinity, liveSync*, liveBackBufferLength = live-specific
 * - Buffer/ABR/retries set for stable live playback
 * - Set lowLatencyMode: true only if your server uses LL-HLS (parts/preload)
 */
export const hlsConf = {
  autoStartLoad: true,
  // Buffer: enough to avoid stalls, not excessive for live
  maxBufferLength: 30,
  maxMaxBufferLength: 60,
  maxBufferSize: 60 * 1000 * 1000, // 60 MB
  maxBufferHole: 0.5,
  lowBufferWatchdogPeriod: 0.5,
  highBufferWatchdogPeriod: 2,
  nudgeOffset: 0.1,
  nudgeMaxRetry: 4,
  maxFragLookUpTolerance: 0.25,
  // --- Live-specific (required for live) ---
  liveDurationInfinity: true,        // live has no end duration
  liveSyncDurationCount: 3,           // stay ~3 segments from live edge (~6–12s typical)
  liveMaxLatencyDurationCount: 10,   // if behind by 10 segments, jump forward to catch up
  liveBackBufferLength: 30,          // keep 30s behind live edge (set 0 to disable rewind, save memory)
  // lowLatencyMode: false,          // set true if server uses LL-HLS (PART segments/preload)
  // Performance
  enableWorker: true,
  startFragPrefetch: true,
  // Load timeouts and retries
  manifestLoadingTimeOut: 15000,
  manifestLoadingMaxRetry: 8,
  manifestLoadingRetryDelay: 1000,
  levelLoadingTimeOut: 10000,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1000,
  fragLoadingTimeOut: 20000,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1000,
  appendErrorMaxRetry: 3,
  // ABR: responsive bitrate switching, avoid starvation
  abrEwmaFastLive: 2.0,
  abrEwmaSlowLive: 8.0,
  abrEwmaFastVoD: 2.0,
  abrEwmaSlowVoD: 8.0,
  abrEwmaDefaultEstimate: 500000,
  abrBandWidthFactor: 0.95,
  abrBandWidthUpFactor: 0.7,
  maxStarvationDelay: 4,
  maxLoadingDelay: 4,
  // Start from auto level for best initial quality
  startLevel: -1,
  // Reduce unnecessary work
  debug: false,
}

export class HlsController {
  constructor() {
    this.errorCallback = (e) => {};
  }

  getConfig() {
    const conf = { ...hlsConf };
    const callback = this.getCallback();
    Object.keys(callback).forEach((k) => {
      conf[k] = callback[k];
    });
    return conf;
  }

  getCallback() {
    let self = this;
    return {
      // xhrSetup callback
      xhrSetup: (xhr, url) => {
        // on Error
        xhr.onerror = function() {
          console.log('----> XHR State:', xhr.status);
          self.errorCallback(xhr.status);
        };
        // Callback if >= 400 state error
        xhr.onloadend = function() {
          if (xhr.status >= 400) {
            console.log('----> XHR State:', xhr.status);
            self.errorCallback(xhr.status);
          }
        };
      }
    };
  }

  /**
   * Set error calback for xhr request.
   **/
  setErrorCallback(errorCallback) {
    this.errorCallback = errorCallback;
  }
}
